import format from '@mobi/utils/formatters/number'
import storage from 'utils/storage'
import entities from 'entities'
import signin from '../signin'
import dateFormat from '@mobi/utils/formatters/date'

import router from 'utils/router'
import jwt_decode from 'jwt-decode'
import getRecaptchaToken from '../../utils/getRecaptchaToken'

const getSessionId = () => {
  try {
    const sessionIdURL = router.getQueryString('sessionId')
    if (sessionIdURL) {
      storage.session.setItem('session_id', sessionIdURL)
      return Promise.resolve(sessionIdURL)
    }
  } catch (error) {
    console.error('sessionIdURL -', error)
  }

  try {
    const sessionId = storage.session.getItem('session_id')
    if (sessionId) {
      return Promise.resolve(sessionId)
    }
  } catch (error) {
    console.error('sessionId -', error)
  }

  try {
    const tokenSession = router.getQueryString('token')
    if (tokenSession) {
      let decoded = jwt_decode(tokenSession)
      decoded = JSON.parse(decoded.data)

      storage.session.setItem('session_id', decoded.session_uuid)

      return Promise.resolve(decoded.session_uuid)
    }
  } catch (error) {
    console.error('getSessionId -', error)
  }
}

const getGroupsBySessionId = async (sessionId, token) => {
  const debtGroups = storage.session.getItem(`${sessionId}-debt-groups`)

  if (debtGroups) {
    return Promise.resolve(debtGroups)
  } else {
    const recaptchaToken = await getRecaptchaToken(token)

    return signin()
      .then(({ http }) => {
        return http
          .get(`session/${sessionId}/debt_groups`, {
            headers: {
              'g-recaptcha-response': recaptchaToken,
            },
          })
          .then(async (data) => {
            const { debt_groups, payment_days } = data

            let debtData = debt_groups?.map((item) => {
              return {
                group: item,
                payment_days: payment_days
                  ?.filter((_, index) => index === 0)
                  .map((day) => dateFormat(day)),
              }
            })

            const debtGroups = debtData.map(entities.DebtGroup)

            return {
              hasDebits: data.has_debits,
              debtGroups,
              userName: data.first_name,
              totalValue: format({
                value: data.debts_total,
                style: 'currency',
              }),
              minimalDiscount: data.minimal_discount,
              maximalDiscount: data.maximal_discount,
              minimalPaymentDay: dateFormat(data?.minimal_payment_day),
              maximalPaymentDay: dateFormat(data?.maximal_payment_day),
              hasDebit: data.has_debts,
              paymentDays: data?.payment_days?.map((day) => dateFormat(day)),
            }
          })
      })
      .then((data) => {
        storage.session.setItem(`${sessionId}-debt-groups`, data)

        storage.session.setItem('groups_selected', data.debtGroups)

        return data
      })
  }
}

const sendWhatsAppBySessionId = ({ cellphone, lead_name, agreements }) => {
  return signin().then(({ http }) => {
    return http.post(`system/whatsapp/agreement_data`, {
      cellphone,
      lead_name,
      channel_name: 'Site Recovery',
      agreements,
    })
  })
}

export default {
  getGroupsBySessionId,
  sendWhatsAppBySessionId,
  getSessionId,
}
